import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Contact = () => {
  const [formData, setFormData] = useState({ 
    name: "", 
    email: "", 
    subject: "", 
    message: "" 
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = "The name is required";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "The name must contain at least 2 characters";
    }
    
    if (!formData.email.trim()) {
      newErrors.email = "The email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "The email is not valid";
    }
    
    if (!formData.subject.trim()) {
      newErrors.subject = "The subject is required";
    } else if (formData.subject.trim().length < 5) {
      newErrors.subject = "The subject must contain at least 5 characters";
    }
    
    if (!formData.message.trim()) {
      newErrors.message = "The message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "The message must contain at least 10 characters";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      const firstErrorField = document.querySelector('.error-field');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    
    setIsSubmitting(true);
    
    emailjs
      .send(
        "service_3bhpda9",
        "template_znqy58m",
        formData,
        "L-loHFaGtckwBdRJE"
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result.text);
          alert("Email sent successfully !");
          setFormData({ name: "", email: "", subject: "", message: "" });
          setErrors({});
        },
        (error) => {
          console.error("Error sending email:", error.text);
          alert("Error sending email. Please try again.");
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <div 
        className="bradcam_area breadcam_bg_3"
        data-aos="fade-down"
        data-aos-delay="200"
      >
        <h3>Contact Us</h3>
      </div>

      <section className="contact-section">
        <div className="container">
          {/* Google Map */}
          <div className="d-none d-sm-block mb-5 pb-4">
            <div id="map" style={{ height: '480px', position: 'relative', overflow: 'hidden' }}>
              <iframe 
                title="Google Map"
                style={{ border: '0', width: '100%', height: '100%' }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3190.567890123456!2d8.802896!3d36.957123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDU3JzI1LjYiTiA4wrA0OCcxMC40IkU!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <h2 className="contact-title">Contact Us</h2>
            </div>
            
            <div className="col-lg-8">
              <form 
                className="form-contact contact_form" 
                onSubmit={handleSubmit}
                id="contactForm" 
                noValidate
              >
                <div className="row">
                  <div className="col-12">
                    <div className={`form-group ${errors.message ? 'error-field' : ''}`}>
                      <textarea 
                        className={`form-control custom-form-control w-100 ${errors.message ? 'is-invalid' : ''}`}
                        name="message" 
                        id="message" 
                        cols="30" 
                        rows="9" 
                        onFocus={(e) => e.target.placeholder = ''} 
                        onBlur={(e) => e.target.placeholder = 'Enter your Message'} 
                        placeholder="Enter your Message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                      {errors.message && (
                        <div className="error-message" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                          {errors.message}
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="col-sm-6">
                    <div className={`form-group ${errors.name ? 'error-field' : ''}`}>
                      <input 
                        className={`form-control custom-form-control ${errors.name ? 'is-invalid' : 'valid'}`}
                        name="name" 
                        id="name" 
                        type="text" 
                        onFocus={(e) => e.target.placeholder = ''} 
                        onBlur={(e) => e.target.placeholder = 'Enter your Name'} 
                        placeholder="Enter your Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      {errors.name && (
                        <div className="error-message" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                          {errors.name}
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="col-sm-6">
                    <div className={`form-group ${errors.email ? 'error-field' : ''}`}>
                      <input 
                        className={`form-control custom-form-control ${errors.email ? 'is-invalid' : 'valid'}`}
                        name="email" 
                        id="email" 
                        type="email" 
                        onFocus={(e) => e.target.placeholder = ''} 
                        onBlur={(e) => e.target.placeholder = 'Enter your Email Address'} 
                        placeholder="Enter your Email Address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      {errors.email && (
                        <div className="error-message" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                          {errors.email}
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="col-12">
                    <div className={`form-group ${errors.subject ? 'error-field' : ''}`}>
                      <input 
                        className={`form-control custom-form-control ${errors.subject ? 'is-invalid' : ''}`}
                        name="subject" 
                        id="subject" 
                        type="text" 
                        onFocus={(e) => e.target.placeholder = ''} 
                        onBlur={(e) => e.target.placeholder = 'Enter the Subject'} 
                        placeholder="Enter the Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                      {errors.subject && (
                        <div className="error-message" style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                          {errors.subject}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="form-group mt-3">
                  <button 
                    type="submit" 
                    className="button button-contactForm boxed-btn"
                    disabled={isSubmitting}
                    style={{ opacity: isSubmitting ? 0.6 : 1 }}
                  >
                    {isSubmitting ? "Sending..." : "Send"}
                  </button>
                </div>
              </form>
            </div>
            
            <div className="col-lg-3 offset-lg-1">
              <div className="media contact-info">
                <span className="contact-info__icon"><i className="ti-home"></i></span>
                <div className="media-body">
                  <h3>Tabarka, Jendouba, Tunisia.</h3>
                  <p>l'îlot U17B, El Morjane</p>
                </div>
              </div>
              
              <div className="media contact-info">
                <span className="contact-info__icon"><i className="ti-tablet"></i></span>
                <div className="media-body">
                  <h3> +216 98 370 055</h3>
                  <p>Mon to Fri from 9AM à 6AM</p>
                </div>
              </div>
              
              <div className="media contact-info">
                <span className="contact-info__icon"><i className="ti-email"></i></span>
                <div className="media-body">
                  <h3>rafikbj@gmail.com</h3>
                  <p>Send Us Your Request Anytime!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;